import {TableSettings} from "../../../../tableSettings";

export const oceanImportLoadPlanList:TableSettings = {
  tableVersion: 10045,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: [
    { accessor:'indicator', Header: '#', visible: true, width: 30, canBeHidden: false, resizable: false, sortable: false },
    { accessor:'postDate', Header: 'Date', visible:true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'loadNo', Header: 'Load #', visible:true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'sName', Header: 'Trucking Company', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'warehouseName', Header: 'Warehouse', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'amount', Header: 'Amount', visible:true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'float' },
    { accessor:'truckingETD', Header: 'Trucking ETD', visible:true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'u2Date', Header: 'Update', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'u2Id', Header: 'Update by', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'u1Id', Header: 'Create by', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
  ]
};

export const oceanImportLoadPlanDetailsList:TableSettings = {
  tableVersion: 1007,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  flexResizer: true,

  alternateRows: true,
  columns: [
    { accessor:'indicator', Header: '#', visible: true, resizable: false, sortable: false, initialWidthPercentage: 4.05, },
    { accessor:'stop', Header: 'Stop', visible: true, resizable: false, sortable: false, initialWidthPercentage: 8.11, },
    { accessor:'hblNo', Header: 'HBL #', visible: true, resizable: false, sortable: false, initialWidthPercentage: 10.81, },
    { accessor:'itNo', Header: 'I.T #', visible: true, resizable: false, sortable: false, initialWidthPercentage: 9.46, },
    { accessor:'pkgs', Header: 'Pkgs', visible: true, resizable: false, sortable: false, initialWidthPercentage: 9.46, },
    { accessor:'cbm', Header: 'Cbm', visible: true, resizable: false, sortable: false, initialWidthPercentage: 9.46, },
    { accessor:'lbs', Header: 'Lbs', visible: true, resizable: false, sortable: false, initialWidthPercentage: 9.46, },
    { accessor:'customer', Header: 'Customer', visible: true, resizable: false, sortable: false, initialWidthPercentage: 13.51, },
    { accessor:'deliverTo', Header: 'Delivery To', visible: true, resizable: false, sortable: false, initialWidthPercentage: 12.16, },
    { accessor:'truETA', Header: 'Trucking ETA', visible: true, resizable: false, sortable: false, initialWidthPercentage: 10.81, },
    { accessor:'scroll', Header: '', visible: true, resizable: false, sortable: false, initialWidthPercentage: 2.71, },
  ]
};